import React from 'react';
import { Card, CardBody, Col, Progress, Row } from 'reactstrap';
import CountUp from 'react-countup';
import { H3, UL, LI } from '../../../AbstractElements';
import { Loss, NewOrder, Profit, ProgressLost, ProgressProfit } from '../../../Constant';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

const ProgressCard = () => {
  return (
    <Col xl='12' md='12' className='box-col-12'>
      <Card className='order-widget'>
        <CardBody>
          <Row className='header-widget'>
            <Col xs='5'>
              <span>{NewOrder}</span>
              <H3>
                <CountUp className='total-num counter' end={25639} />
              </H3>
            </Col>
            <Col xs='7'>
              <div className='text-end'>
                <UL className='simple-list '>
                  <LI>
                    {Profit}
                    <span className='product-stts font-primary m-l-10'>
                      {ProgressProfit}
                      <FaAngleUp className='f-12 m-l-10' />
                    </span>
                  </LI>
                  <LI>
                    {Loss}
                    <span className='product-stts font-primary m-l-10'>
                      {ProgressLost}
                      <FaAngleDown className='f-12 m-l-10' />
                    </span>
                  </LI>
                </UL>
              </div>
            </Col>
          </Row>
          <div className='new-order'>
            <div>
              <Progress className='sm-progress-bar' value={80} color='primary' />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProgressCard;
